// Ce fichier contient la logique JavaScript pour la réservation de créneaux
// Les données doivent être initialisées depuis le fichier Blade

export function initSlotsBooking(slotsData, clinicProximityMapData, appointmentReasonsByAgeData, maxSlotsPerDay, locale = 'fr', translations = {}) {
    const slots = slotsData;
    const clinicProximityMap = clinicProximityMapData;
    const appointmentReasonsByAge = appointmentReasonsByAgeData;
    const maxSlotsPerDayWithPractitioner = maxSlotsPerDay;
    const currentLocale = locale;
    const trans = translations;


    // Variable globale pour tracker l'âge du patient
    let currentPatientAge = 'adulte'; // Par défaut : adulte

    // --- FONCTION POUR METTRE À JOUR L'ÂGE DU PATIENT ---
    window.updatePatientAge = function (age) {
        currentPatientAge = age;

        // Réinitialiser la sélection du motif
        const reasonInputs = document.querySelectorAll('input[name="reason"]');
        reasonInputs.forEach(input => input.checked = false);

        // ✅ Réinitialiser le praticien sélectionné
        currentSelectedPractitioner = '';
        if (practitionerSearch) {
            practitionerSearch.value = '';
        }

        // Évite de conserver un créneau désormais obsolète (hidden inputs + barre sticky)
        resetSelectedSlot();

        // ✅ Masquer/afficher le bouton "Autres" selon l'âge sélectionné
        const otherReasonOption = document.getElementById('other-reason-option');
        if (otherReasonOption) {
            const agesWithAutres = (otherReasonOption.dataset.agesWith || otherReasonOption.dataset.agesWithAutres || '').split(',').filter(Boolean);
            if (agesWithAutres.length > 0 && !agesWithAutres.includes(age)) {
                otherReasonOption.style.display = 'none';
                // Désélectionner si c'était sélectionné
                const otherInput = otherReasonOption.querySelector('input[type="radio"]');
                if (otherInput && otherInput.checked) {
                    otherInput.checked = false;
                }
            } else {
                otherReasonOption.style.display = '';
            }
        }

        // ✅ NOUVEAU : Déclencher un événement pour réinitialiser Alpine.js
        window.dispatchEvent(new CustomEvent('patient-age-changed', {
            detail: {age: age}
        }));

        // Mettre à jour les motifs disponibles et leurs prix
        updateReasonPrices();
        updateReasonAvailability();
        updatePractitionerOptions(); // ✅ Mettre à jour les praticiens
        applyFilters();

        // Mettre à jour l'affichage des descriptions
        updateDescriptionsVisibility();
    };

    // --- FONCTION POUR METTRE À JOUR LA VISIBILITÉ DES DESCRIPTIONS ---
    function updateDescriptionsVisibility() {
        // Récupérer toutes les divs de description
        const descriptionDivs = document.querySelectorAll('[data-description-age]');
        descriptionDivs.forEach(div => {
            const descAge = div.getAttribute('data-description-age');
            const descReason = div.getAttribute('data-description-reason');

            // Vérifier si cette description doit être visible
            const reasonInput = document.querySelector(`input[name="reason"]:checked`);
            const selectedReason = reasonInput ? reasonInput.value : '';
            const isOther = document.querySelector('#other-reason-option input:checked') !== null;

            if (selectedReason === descReason && !isOther && currentPatientAge === descAge) {
                div.style.display = 'block';
            } else {
                div.style.display = 'none';
            }
        });
    }

    const form = document.querySelector('form');
    const selectedBookId = document.getElementById('selectedBookId');
    const modal = document.getElementById('clinic-modal');
    const clinicOptions = document.getElementById('clinic-options');
    const practitionerSearch = document.getElementById('practitionerSearch');
    const practitionersList = document.getElementById('practitioners-list');
    const practitionersOptions = document.getElementById('practitioners-options');
    const slotError = document.getElementById('slot-error');

    // Variable globale pour le praticien sélectionné
    let currentSelectedPractitioner = '';

    // --- Gestion de l'affichage de la liste des praticiens ---
    practitionerSearch.addEventListener('focus', () => {
        practitionersList.classList.remove('hidden');
    });

    practitionerSearch.addEventListener('input', (e) => {
        window.filterPractitioners(e.target.value);
    });

    // Fermer la liste au clic en dehors
    document.addEventListener('click', (e) => {
        if (!practitionerSearch.contains(e.target) && !practitionersList.contains(e.target)) {
            practitionersList.classList.add('hidden');
        }
    });

    // --- UTILITAIRE pour récupérer les cliniques sélectionnées ---
    function getSelectedClinics() {
        return Array.from(document.querySelectorAll('input[name="clinics[]"]:checked'))
            .map(input => input.value);
    }

    // --- UTILITAIRE pour formater le nom du praticien ---
    // Inverse l'ordre des mots : "Dupont Henri Dr." → "Dr. Henri Dupont"
    function formatPractitionerName(name) {
        if (!name) return '';
        const words = name.split(' ').filter(w => w.trim() !== '');
        return words.reverse().join(' ');
    }

    // --- FONCTION POUR METTRE À JOUR LES PRIX DES MOTIFS ---
    function updateReasonPrices() {
        // Utiliser la configuration par âge du patient
        const ageConfig = appointmentReasonsByAge[currentPatientAge] || {};

        // Mettre à jour l'affichage des prix selon l'âge
        document.querySelectorAll('.reason-price').forEach(priceSpan => {
            const category = priceSpan.dataset.category;
            if (ageConfig[category] && ageConfig[category].prix) {
                priceSpan.innerText = ageConfig[category].prix;
            } else {
                priceSpan.innerText = '';
            }
        });
    }

    // --- UTILITAIRE pour récupérer le motif sélectionné ---
    function getSelectedReason() {
        const checked = document.querySelector('input[name="reason"]:checked');
        return checked ? checked.value : '';
    }

    // --- Fermeture modal ---
    function closeModal() {
        modal.classList.add('hidden');
        clinicOptions.innerHTML = '';
    }

    // Exposer globalement pour utilisation dans le HTML
    window.closeModal = closeModal;

    // --- Récupération des praticiens uniques ---
    const practitioners = [...new Set(slots.map(slot => slot.PractitionerID))].sort();

    // --- Fonction pour sélectionner un slot ---
    function selectSlot(slot) {
        selectedBookId.value = slot.BookID;
        document.getElementById('selectedClinic').value = slot.clinic;
        document.getElementById('selectedDate').value = slot.date;
        document.getElementById('selectedHour').value = slot.Hour;
        document.getElementById('selectedClinicId').value = slot.clinic_id;
        document.getElementById('selectedPractitioner').value = slot.Practitioner;
        document.getElementById('selectedPractitionerType').value = slot.practitioner_type;
        document.getElementById('ReasonID').value = slot.ReasonID;
        document.getElementById('practitionerID').value = slot.PractitionerID;
        slotError.classList.add('hidden');

        // Afficher la barre de rendez-vous
        const slotBar = document.getElementById('slot-bar');
        if (slotBar) {
            slotBar.classList.remove('hidden');
        }

        // Les champs cachés viennent d'être renseignés par programme, ce qui ne
        // déclenche aucun événement. Sans cette notification explicite, les
        // écouteurs branchés sur selectedBookId — dont le traçage de la
        // sélection de créneau — ne verraient jamais passer le choix du
        // visiteur, alors que c'est l'étape la plus intéressante du parcours.
        selectedBookId.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // --- Réinitialiser le créneau sélectionné ---
    function resetSelectedSlot() {
        selectedBookId.value = '';
        const fields = ['selectedClinic', 'selectedDate', 'selectedHour', 'selectedClinicId',
            'selectedPractitioner', 'selectedPractitionerType', 'ReasonID', 'practitionerID'];
        fields.forEach(id => {
            const el = document.getElementById(id);
            if (el) el.value = '';
        });
        // Masquer la barre de rendez-vous
        const slotBar = document.getElementById('slot-bar');
        if (slotBar) slotBar.classList.add('hidden');
        // Retirer le highlight de tous les boutons
        document.querySelectorAll('#slots-columns button').forEach(b => {
            b.classList.remove('ring-4', 'ring-pink-500', 'from-pink-500', 'to-pink-400');
            b.classList.add('from-blue-600', 'to-blue-500');
        });
    }

    // --- Mettre en surbrillance un slot ---
    function highlightSlot(btn) {
        // Retirer le highlight de tous les boutons
        document.querySelectorAll('#slots-columns button')
            .forEach(b => {
                b.classList.remove('ring-4', 'ring-pink-500', 'from-pink-500', 'to-pink-400');
                b.classList.add('from-blue-600', 'to-blue-500');
            });

        // Ajouter le highlight au bouton sélectionné
        btn.classList.remove('from-blue-600', 'to-blue-500');
        btn.classList.add('ring-4', 'ring-pink-500', 'from-pink-500', 'to-pink-400');
    }

    // Exemple : convertir "2026-01-24" en "Samedi 24 janvier" (ou selon la locale)
    function formatDateFR(dateStr) {
        const date = new Date(dateStr);

        // Map des locales Laravel vers locales JavaScript
        const localeMap = {
            'fr': 'fr-FR',
            'de': 'de-DE',
            'it': 'it-IT',
            'en': 'en-GB'
        };

        const jsLocale = localeMap[currentLocale] || 'fr-FR';

        return new Intl.DateTimeFormat(jsLocale, {
            weekday: 'long',  // jour de la semaine
            day: 'numeric',   // numéro du jour
            month: 'long'     // mois en lettres
        }).format(date);
    }

    function deduplicateSlotsForDisplay(data, reason = '') {
        const seen = new Set();

        return data.filter(slot => {
            // Déduplication uniquement dans le contexte d'affichage courant
            // (catégorie sélectionnée), jamais globalement entre catégories.
            const categoryKey = normalizeString(reason || slot.category || '');
            const practitionerKey = slot.PractitionerID || normalizeString(slot.Practitioner || '');
            const key = [
                categoryKey,
                practitionerKey,
                slot.date || '',
                slot.Hour || '',
            ].join('|');

            if (seen.has(key)) {
                return false;
            }

            seen.add(key);
            return true;
        });
    }

    // --- RENDER DES CRÉNEAUX ---
    function renderSlots(data) {
        const container = document.getElementById('slots-columns');
        container.innerHTML = '';

        const slotsToRender = deduplicateSlotsForDisplay(data, getSelectedReason());

        if (!slotsToRender.length) {
            container.innerHTML = `<div class="text-gray-300 text-center py-4 w-full">Aucun créneau disponible, veuillez nous contacter au <a href="tel:058 234 00 00">058 234 00 00</a></div>`;
            return;
        }

        const dates = [...new Set(slotsToRender.map(slot => slot.date))].sort();

        dates.forEach(date => {
            const col = document.createElement('div');
            col.className = 'flex flex-col bg-blue-800 p-2 rounded min-w-[180px]';

            const title = document.createElement('div');
            title.className = 'font-semibold text-center text-white mb-2 sticky top-0 bg-blue-800 z-10 py-2 -mt-2';
            title.innerText = formatDateFR(date);
            col.appendChild(title);

            let slotsForDate = slotsToRender.filter(slot => slot.date === date);
            const totalSlotsForDate = slotsForDate.length;
            let limitApplied = false;

            // ✅ NOUVEAU : Limiter le nombre de créneaux si un praticien est sélectionné
            if (currentSelectedPractitioner && maxSlotsPerDayWithPractitioner > 0) {
                if (totalSlotsForDate > maxSlotsPerDayWithPractitioner) {
                    slotsForDate = slotsForDate.slice(0, maxSlotsPerDayWithPractitioner);
                    limitApplied = true;
                }
            }

            const slotsGrouped = {};
            slotsForDate.forEach(slot => {
                if (!slotsGrouped[slot.Hour]) slotsGrouped[slot.Hour] = [];
                slotsGrouped[slot.Hour].push(slot);
            });

            Object.entries(slotsGrouped).forEach(([hour, slots]) => {
                // ...existing button creation code...
                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'bg-gradient-to-r text-white py-2 px-3 rounded mb-2 w-full text-left flex flex-col items-start justify-center space-y-1 transition-all duration-200';
                // Ajouter les classes de couleur par défaut (bleu)
                btn.classList.add('from-blue-600', 'to-blue-500');

                const hourDiv = document.createElement('div');
                hourDiv.className = 'font-semibold text-white';
                hourDiv.innerText = hour;
                btn.appendChild(hourDiv);

                const clinicsDiv = document.createElement('div');
                clinicsDiv.className = 'flex flex-wrap gap-1';

                slots.forEach(slot => {
                    const wrapper = document.createElement('span');
                    wrapper.className = 'relative';

                    const clinicBadge = document.createElement('span');
                    clinicBadge.className = 'bg-white text-blue-700 text-xs px-2 py-0.5 rounded cursor-help';
                    clinicBadge.innerText = slot.clinic;

                    const tooltip = document.createElement('div');
                    tooltip.className = 'absolute z-50 hidden whitespace-nowrap bg-blue-900 text-white text-xs rounded px-2 py-1 -top-8 left-1/2 -translate-x-1/2 shadow-lg';
                    tooltip.innerText = formatPractitionerName(slot.Practitioner);

                    clinicBadge.addEventListener('mouseenter', () => tooltip.classList.remove('hidden'));
                    clinicBadge.addEventListener('mouseleave', () => tooltip.classList.add('hidden'));

                    wrapper.appendChild(clinicBadge);
                    wrapper.appendChild(tooltip);
                    clinicsDiv.appendChild(wrapper);
                });

                btn.appendChild(clinicsDiv);

                // Ajouter l'effet de hover avec ring-4
                btn.addEventListener('mouseenter', () => {
                    btn.classList.add('ring-4', 'ring-pink-500');
                });

                btn.addEventListener('mouseleave', () => {
                    // Ne retirer le ring-4 que si ce n'est pas le bouton sélectionné
                    if (!btn.classList.contains('from-pink-500')) {
                        btn.classList.remove('ring-4', 'ring-pink-500');
                    }
                });

                btn.onclick = () => {
                    if (slots.length === 1) {
                        selectSlot(slots[0]);
                        highlightSlot(btn);
                    } else {
                        clinicOptions.innerHTML = '';
                        slots.forEach(slot => {
                            const clinicBtn = document.createElement('button');
                            clinicBtn.type = 'button';
                            clinicBtn.className = 'bg-pink-600 hover:bg-pink-500 text-white px-4 py-2 rounded w-full';
                            clinicBtn.innerText = slot.clinic + " " + (trans.with || 'avec') + " " + formatPractitionerName(slot.Practitioner);
                            clinicBtn.onclick = () => {
                                selectSlot(slot);
                                closeModal();
                                highlightSlot(btn);
                            };
                            clinicOptions.appendChild(clinicBtn);
                        });
                        modal.classList.remove('hidden');
                        modal.classList.add('flex');
                    }
                };

                col.appendChild(btn);
            });

            // ✅ NOUVEAU : Ajouter un indicateur si plus de créneaux disponibles
            if (limitApplied) {
                const moreInfo = document.createElement('div');
                moreInfo.className = 'text-blue-200 text-xs text-center mt-2 px-2 py-1 bg-blue-700 rounded';
                moreInfo.innerHTML = `+${totalSlotsForDate - maxSlotsPerDayWithPractitioner} autres créneaux<br><span class="text-xs opacity-75">Désélectionnez le praticien pour voir tous les créneaux</span>`;
                col.appendChild(moreInfo);
            }

            container.appendChild(col);
        });

        // Mettre à jour l'état des boutons de navigation
        // Utiliser setTimeout pour s'assurer que le DOM est complètement rendu
        setTimeout(() => {
            updateNavigationButtons();
        }, 100);
    }

    // --- FONCTIONS DE NAVIGATION DES CRÉNEAUX ---
    function scrollSlotsLeft() {
        const container = document.getElementById('slots-container');
        const scrollAmount = 400; // Pixels à scroller
        container.scrollBy({
            left: -scrollAmount,
            behavior: 'smooth'
        });
        // Mettre à jour les boutons après un court délai
        setTimeout(updateNavigationButtons, 300);
    }

    function scrollSlotsRight() {
        const container = document.getElementById('slots-container');
        const scrollAmount = 400; // Pixels à scroller
        container.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
        });
        // Mettre à jour les boutons après un court délai
        setTimeout(updateNavigationButtons, 300);
    }

    // Exposer globalement pour utilisation dans le HTML
    window.scrollSlotsLeft = scrollSlotsLeft;
    window.scrollSlotsRight = scrollSlotsRight;

    function updateNavigationButtons() {
        const container = document.getElementById('slots-container');
        const prevBtn = document.getElementById('slots-prev-btn');
        const nextBtn = document.getElementById('slots-next-btn');

        if (!container || !prevBtn || !nextBtn) return;

        const columns = document.getElementById('slots-columns');
        if (!columns || columns.children.length === 0) {
            // Pas de créneaux : désactiver les boutons
            prevBtn.disabled = true;
            nextBtn.disabled = true;
            return;
        }

        // Vérifier si le contenu est scrollable
        const isScrollable = container.scrollWidth > container.clientWidth;

        if (!isScrollable) {
            // Pas de scroll nécessaire : désactiver les deux boutons
            prevBtn.disabled = true;
            nextBtn.disabled = true;
            return;
        }

        // Vérifier si on peut scroller à gauche
        prevBtn.disabled = container.scrollLeft <= 0;

        // Vérifier si on peut scroller à droite
        nextBtn.disabled = container.scrollLeft + container.clientWidth >= container.scrollWidth - 5;
    }

    // Écouter les événements de scroll pour mettre à jour les boutons
    document.addEventListener('DOMContentLoaded', () => {
        const container = document.getElementById('slots-container');
        if (container) {
            container.addEventListener('scroll', updateNavigationButtons);
        }
    });

    // Rendre les fonctions accessibles globalement
    window.scrollSlotsLeft = scrollSlotsLeft;
    window.scrollSlotsRight = scrollSlotsRight;

    // --- METTRE À JOUR LES PRATICIENS ---
    function updatePractitionerOptions() {
        const selectedClinics = getSelectedClinics();
        const reason = getSelectedReason();

        let filteredSlots = slots;

        // Filtrer par clinique si sélectionnée
        if (selectedClinics.length > 0) {
            filteredSlots = filteredSlots.filter(slot => selectedClinics.includes(slot.clinic_id.toString()));
        }
        // Si aucune clinique sélectionnée, on garde tous les slots

        // Filtrer par motif si sélectionné
        if (reason) {
            filteredSlots = filteredSlots.filter(slot => slot.category === reason);
        }

        // ✅ NOUVEAU : Filtrer selon l'âge du patient et les sous-catégories
        filteredSlots = filteredSlots.filter(slot => slotMatchesPatientAge(slot));

        // Utiliser le NOM du praticien comme clé pour éviter les doublons d'ID
        // et stocker aussi le type de praticien
        const practitionersMap = {};
        filteredSlots.forEach(slot => {
            if (!practitionersMap.hasOwnProperty(slot.Practitioner)) {
                practitionersMap[slot.Practitioner] = {
                    name: slot.Practitioner,
                    type: slot.practitioner_type
                };
            }
        });

        // Générer les options dans le nouveau système
        practitionersOptions.innerHTML = '';

        // Trier par nom de praticien EN ORDRE ALPHABÉTIQUE
        Object.values(practitionersMap)
            .sort((a, b) => {
                // Formater les noms pour la comparaison
                const nameA = formatPractitionerName(a.name).toLowerCase();
                const nameB = formatPractitionerName(b.name).toLowerCase();
                return nameA.localeCompare(nameB, 'fr');
            })
            .forEach((practitioner) => {
                const practitionerDiv = document.createElement('div');
                practitionerDiv.className = 'practitioner-item px-4 py-3 hover:bg-blue-50 cursor-pointer border-b border-gray-200 flex items-center justify-between';
                practitionerDiv.dataset.name = practitioner.name;

                const nameSpan = document.createElement('span');
                nameSpan.className = 'font-medium text-gray-900';
                nameSpan.innerText = formatPractitionerName(practitioner.name);

                const badge = document.createElement('span');
                badge.className = 'text-xs px-2 py-1 rounded-full flex-shrink-0';

                // Normaliser le type pour la comparaison
                const typeNormalized = (practitioner.type || '').toLowerCase().trim();

                // Définir la couleur et le texte selon le type
                if (typeNormalized.includes('md') ||
                    typeNormalized.includes('dentiste') ||
                    typeNormalized === 'médecin-dentiste') {
                    badge.className += ' bg-blue-100 text-blue-700';
                    badge.innerText = 'Médecin-dentiste';
                } else if (typeNormalized.includes('hd') ||
                    typeNormalized.includes('hygiéniste') ||
                    typeNormalized.includes('hygieniste')) {
                    badge.className += ' bg-green-100 text-green-700';
                    badge.innerText = 'Hygiéniste dentaire';
                } else {
                    badge.className += ' bg-gray-100 text-gray-700';
                    badge.innerText = practitioner.type || 'Praticien';
                }

                // Nom à GAUCHE, Badge à DROITE
                practitionerDiv.appendChild(nameSpan);
                practitionerDiv.appendChild(badge);

                practitionerDiv.addEventListener('click', () => {
                    selectPractitioner(practitioner.name);
                });

                practitionersOptions.appendChild(practitionerDiv);
            });
    }

    // --- FONCTION POUR SÉLECTIONNER UN PRATICIEN ---
    window.selectPractitioner = function (name) {
        currentSelectedPractitioner = name;
        practitionerSearch.value = name ? formatPractitionerName(name) : '';
        practitionersList.classList.add('hidden');
        resetSelectedSlot();
        updateReasonAvailability();
        updateAllSubcategoriesAvailability();
        applyFilters();
    }

    // --- FONCTION GÉNÉRIQUE : disponibilité de toutes les sous-catégories ---
    // Émet un seul event "subcategories-availability-updated" avec une map
    // { "catKey__subKey": bool } couvrant TOUTES les catégories ayant des sous-catégories.
    function updateAllSubcategoriesAvailability() {
        const selectedClinics = getSelectedClinics();
        const ageConfig = appointmentReasonsByAge[currentPatientAge] ?? {};
        const availability = {};

        // Itérer sur toutes les catégories du groupe d'âge courant
        for (const [catKey, catData] of Object.entries(ageConfig)) {
            if (!catData.subcategories) continue;

            // Slots filtrés pour cette catégorie (clinique + praticien)
            let catSlots = slots.filter(slot => {
                const slotCat = normalizeString(slot.category || '');
                if (slotCat !== normalizeString(catKey)) return false;
                if (selectedClinics.length > 0 && !selectedClinics.includes(slot.clinic_id.toString())) return false;
                if (currentSelectedPractitioner && slot.Practitioner !== currentSelectedPractitioner) return false;
                return true;
            });

            // Pour chaque sous-catégorie, vérifier si au moins un slot correspond
            for (const [subKey, subData] of Object.entries(catData.subcategories)) {
                const alpineKey = catKey + '__' + subKey;
                const motifs = subData.motifs || [];

                if (motifs.length === 0) {
                    availability[alpineKey] = catSlots.length > 0;
                } else {
                    availability[alpineKey] = catSlots.some(slot => {
                        const slotReason = normalizeString(slot.ReasonName || slot.duration || '');
                        return motifs.some(m => slotReason.includes(normalizeString(m)));
                    });
                }
            }
        }

        window.dispatchEvent(new CustomEvent('subcategories-availability-updated', {
            detail: availability
        }));
    }

    // --- FONCTION POUR FILTRER LA LISTE DES PRATICIENS ---
    window.filterPractitioners = function (query) {
        const items = practitionersOptions.querySelectorAll('.practitioner-item');
        const searchTerm = query.toLowerCase();

        items.forEach(item => {
            const name = item.dataset.name.toLowerCase();
            if (name.includes(searchTerm)) {
                item.style.display = 'flex';
            } else {
                item.style.display = 'none';
            }
        });

        practitionersList.classList.remove('hidden');
    }

    // Ajoutez cette fonction utilitaire au début de votre script
    function normalizeString(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    }

    // --- UTILITAIRE : récupérer la config d'une catégorie de manière robuste (insensible aux accents) ---
    function getCategoryConfig(ageConfig, categoryKey) {
        if (!ageConfig || !categoryKey) return null;
        // Accès direct (cas nominal)
        if (ageConfig[categoryKey]) return ageConfig[categoryKey];
        // Fallback : recherche normalisée (accents différents entre slot.category et ageConfig)
        const keyNorm = normalizeString(categoryKey);
        for (const [k, v] of Object.entries(ageConfig)) {
            if (normalizeString(k) === keyNorm) return v;
        }
        return null;
    }

    // --- FONCTION HELPER : Vérifier si un slot correspond à l'âge du patient (catégorie seulement, sans sous-catégorie) ---
    // Utilisé pour updateReasonAvailability afin de ne pas décocher une catégorie
    // quand aucun créneau ne correspond à la sous-catégorie actuellement sélectionnée.
    function slotMatchesPatientAgeCategory(slot) {
        const ageConfig = appointmentReasonsByAge[currentPatientAge];
        if (!ageConfig || !slot.category) return true;

        const categoryConfig = getCategoryConfig(ageConfig, slot.category);
        if (!categoryConfig) return false;

        const allowedMotifs = categoryConfig.motifs || [];
        if (allowedMotifs.length === 0) {
            if (categoryConfig.subcategories) {
                const slotReason = normalizeString(slot.ReasonName || slot.duration || '');
                return Object.values(categoryConfig.subcategories).some(sub =>
                    (sub.motifs || []).some(m => slotReason.includes(normalizeString(m)))
                );
            }
            return true;
        }

        const slotReason = normalizeString(slot.ReasonName || slot.duration || '');
        return allowedMotifs.some(motif => slotReason.includes(normalizeString(motif)));
    }

    // --- FONCTION HELPER : Vérifier si un slot correspond à l'âge du patient ---
    function slotMatchesPatientAge(slot) {
        const ageConfig = appointmentReasonsByAge[currentPatientAge];
        if (!ageConfig || !slot.category) return true;

        const categoryConfig = getCategoryConfig(ageConfig, slot.category);
        if (!categoryConfig) return false;

        // Si la catégorie a des sous-catégories, filtrer selon la sélection courante
        if (categoryConfig.subcategories) {
            let selectedSub = '';
            if (slot.category === 'autres') {
                const el = document.getElementById('otherSubcategory');
                selectedSub = el ? el.value : '';
            } else {
                const inputName = slot.category + '_subcategory_value';
                const el = document.querySelector(`input[name="${inputName}"]`);
                selectedSub = el ? el.value : '';
            }

            if (selectedSub && categoryConfig.subcategories[selectedSub]) {
                const allowedMotifs = categoryConfig.subcategories[selectedSub].motifs || [];
                if (allowedMotifs.length > 0) {
                    const slotReason = normalizeString(slot.ReasonName || slot.duration || '');
                    return allowedMotifs.some(m => slotReason.includes(normalizeString(m)));
                }
                // Fallback motifs globaux si sous-catégorie sans motifs
                const fallbackMotifs = categoryConfig.motifs || [];
                if (fallbackMotifs.length === 0) return true;
                const slotReasonFb = normalizeString(slot.ReasonName || slot.duration || '');
                return fallbackMotifs.some(m => slotReasonFb.includes(normalizeString(m)));
            }

            // Pas de sous-catégorie sélectionnée → motifs globaux
            const globalMotifs = categoryConfig.motifs || [];
            if (globalMotifs.length === 0) return true;
            const slotReason = normalizeString(slot.ReasonName || slot.duration || '');
            return globalMotifs.some(m => slotReason.includes(normalizeString(m)));
        }

        // Catégorie sans sous-catégories : motifs globaux
        const allowedMotifs = categoryConfig.motifs || [];
        if (allowedMotifs.length === 0) return true;
        const slotReason = normalizeString(slot.ReasonName || slot.duration || '');
        return allowedMotifs.some(motif => slotReason.includes(normalizeString(motif)));
    }

    // --- FILTRER LES CRÉNEAUX ---
    function applyFilters() {
        const selectedClinics = getSelectedClinics();
        const reason = getSelectedReason();
        const practitioner = currentSelectedPractitioner || null;

        const noReasonMessage = document.getElementById('no-reason-message');
        const navContainer = document.getElementById('slots-navigation-container');
        const nearbyMessage = document.getElementById('nearby-clinics-message');

        if (!reason) {
            noReasonMessage.classList.remove('hidden');
            navContainer.classList.add('hidden');
            nearbyMessage.classList.add('hidden');
            return;
        }

        noReasonMessage.classList.add('hidden');
        navContainer.classList.remove('hidden');

        // Variable pour tracker si on utilise des cliniques proches
        let usingNearbyClinics = false;
        let nearbyClinicsUsed = [];

        // ========================================
        // NOUVELLE LOGIQUE DE SÉLECTION DES CLINIQUES
        // ========================================

        let clinicsToShow = [];

        if (selectedClinics.length === 0) {
            // AUCUNE CLINIQUE SÉLECTIONNÉE : toutes les cliniques sont candidates
            // Le filtre fin est appliqué en aval (slotMatchesPatientAge)
            clinicsToShow = [...new Set(slots.map(slot => slot.clinic_id.toString()))];
        } else {
            // UNE OU PLUSIEURS CLINIQUES SÉLECTIONNÉES

            // Filtrer les slots selon les cliniques sélectionnées et le motif
            let slotsForSelectedClinics = slots.filter(slot => {
                if (!selectedClinics.includes(slot.clinic_id.toString())) return false;
                if (reason && normalizeString(slot.category) !== normalizeString(reason)) return false;
                if (practitioner && slot.Practitioner !== practitioner) return false;
                if (!slotMatchesPatientAge(slot)) return false; // ✅ Filtre âge
                return true;
            });

            if (slotsForSelectedClinics.length > 0) {
                // DES CRÉNEAUX SONT DISPONIBLES : afficher uniquement les cliniques sélectionnées
                clinicsToShow = selectedClinics;
            } else {
                // AUCUN CRÉNEAU DISPONIBLE : chercher dans les cliniques proches

                let nearbyClinics = [];

                // Récupérer toutes les cliniques proches configurées
                selectedClinics.forEach(clinicId => {
                    if (clinicProximityMap[clinicId]) {
                        nearbyClinics.push(...clinicProximityMap[clinicId]);
                    }
                });

                // Dédupliquer
                nearbyClinics = [...new Set(nearbyClinics)];

                // Vérifier que les cliniques proches ont effectivement des créneaux pour ce motif
                let nearbyClinicsWithSlots = [];

                nearbyClinics.forEach(clinicId => {
                    const hasSlots = slots.some(slot => {
                        if (slot.clinic_id.toString() !== clinicId.toString()) return false;
                        if (reason && normalizeString(slot.category) !== normalizeString(reason)) return false;
                        if (practitioner && slot.Practitioner !== practitioner) return false;
                        if (!slotMatchesPatientAge(slot)) return false; // ✅ Filtre âge
                        return true;
                    });

                    if (hasSlots) {
                        nearbyClinicsWithSlots.push(clinicId.toString());
                    }
                });

                if (nearbyClinicsWithSlots.length > 0) {
                    clinicsToShow = [...selectedClinics, ...nearbyClinicsWithSlots];

                    // Marquer qu'on utilise des cliniques proches
                    usingNearbyClinics = true;
                    nearbyClinicsUsed = nearbyClinicsWithSlots;
                } else {
                    clinicsToShow = selectedClinics;
                }
            }
        }

        // Filtrer les slots selon les cliniques à afficher ET l'âge du patient
        const filtered = slots.filter(slot => {
            if (!clinicsToShow.includes(slot.clinic_id.toString())) return false;
            if (reason && normalizeString(slot.category) !== normalizeString(reason)) return false;
            if (practitioner && slot.Practitioner !== practitioner) return false;
            // ✅ NOUVEAU : Filtrer selon l'âge du patient
            return slotMatchesPatientAge(slot);

        });


        // Afficher le message des cliniques proches
        if (usingNearbyClinics && nearbyClinicsUsed.length > 0) {
            const nearbyClinicNames = nearbyClinicsUsed.map(clinicId => {
                const clinicSlot = slots.find(s => s.clinic_id.toString() === clinicId.toString());
                return clinicSlot ? clinicSlot.clinic : `Clinique ${clinicId}`;
            });

            const nearbyList = document.getElementById('nearby-clinics-list');
            nearbyList.innerHTML = nearbyClinicNames.map(name =>
                `<span class="inline-block bg-blue-600 text-white text-sm px-3 py-1 rounded-full ring-2 ring-pink-500">${name}</span>`
            ).join('');

            nearbyMessage.classList.remove('hidden');
        } else {
            nearbyMessage.classList.add('hidden');
        }

        renderSlots(filtered);
    }

    // --- GRISER LES MOTIFS NON DISPONIBLES ---
    // Règles :
    // - Un motif DÉJÀ SÉLECTIONNÉ n'est jamais grisé ni désactivé
    // - On regarde uniquement les cliniques sélectionnées (PAS les proches)
    function updateReasonAvailability() {
        const selectedClinics = getSelectedClinics();
        const practitioner = currentSelectedPractitioner || null;
        const currentReason = getSelectedReason();
        const hasClinicFilter = selectedClinics.length > 0;

        let filteredSlots = slots;

        if (hasClinicFilter) {
            // Uniquement les cliniques sélectionnées — sans cliniques proches
            filteredSlots = filteredSlots.filter(slot =>
                selectedClinics.includes(slot.clinic_id.toString())
            );
        }

        if (practitioner) {
            filteredSlots = filteredSlots.filter(slot => slot.Practitioner === practitioner);
        }

        filteredSlots = filteredSlots.filter(slot => slotMatchesPatientAgeCategory(slot));

        const availableReasons = new Set(filteredSlots.map(slot => slot.category));

        document.querySelectorAll('.reason-option').forEach(option => {
            const reasonValue = option.dataset.reason;
            const radioInput = option.querySelector('input[type="radio"]');
            const unavailableMsg = option.querySelector('.reason-unavailable-msg');
            const priceSpan = option.querySelector('.reason-price');
            const nameSpan = option.querySelector('.reason-name');

            // Le motif sélectionné n'est JAMAIS grisé, JAMAIS désactivé
            const isSelected = reasonValue === currentReason;
            const isAvailable = availableReasons.has(reasonValue);

            if (isAvailable || !hasClinicFilter || isSelected) {
                // Motif disponible ou sélectionné — apparence normale
                option.classList.remove('opacity-60', 'bg-gray-50', 'border-red-200');
                option.classList.add('hover:border-blue-500');
                option.style.cursor = 'pointer';
                option.style.pointerEvents = '';
                // Ne JAMAIS mettre disabled sur un radio lié à x-model (Alpine vide la valeur)
                if (radioInput) radioInput.disabled = false;
                // if (unavailableMsg) unavailableMsg.classList.add('hidden');
                if (priceSpan) priceSpan.classList.remove('hidden');
                if (nameSpan) {
                    nameSpan.classList.remove('text-gray-400');
                    nameSpan.classList.add('text-gray-900');
                }
            } else {
                // Motif non disponible et non sélectionné — grisage visuel uniquement
                //option.classList.add('opacity-60', 'bg-gray-50', 'border-red-200');
                //option.classList.remove('hover:border-blue-500');
                //option.style.cursor = 'not-allowed';
                // Bloquer le clic via CSS, PAS via disabled (évite qu'Alpine vide selectedReason)
                //option.style.pointerEvents = 'none';
                // if (radioInput) radioInput.disabled = false; // Jamais disabled
                // if (unavailableMsg) unavailableMsg.classList.remove('hidden');
                // if (priceSpan) priceSpan.classList.add('hidden');
                /*if (nameSpan) {
                    nameSpan.classList.add('text-gray-400');
                    nameSpan.classList.remove('text-gray-900');
                }*/
            }
        });
    }

    // --- GRISER LES CLINIQUES SANS CRÉNEAUX POUR LE MOTIF SÉLECTIONNÉ ---
    function updateClinicAvailability() {
        const reason = getSelectedReason();

        document.querySelectorAll('.clinic-option').forEach(option => {
            const clinicId = option.dataset.clinicId;
            const unavailableMsg = option.querySelector('.clinic-unavailable-msg');
            const nameSpan = option.querySelector('.clinic-name');

            if (!reason) {
                // Aucun motif sélectionné : toutes les cliniques normales
                option.classList.remove('opacity-50', 'cursor-not-allowed');
                option.classList.add('hover:border-pink-500', 'cursor-pointer');
                if (unavailableMsg) unavailableMsg.classList.add('hidden');
                if (nameSpan) { nameSpan.classList.remove('text-gray-400'); nameSpan.classList.add('text-gray-900'); }
                return;
            }

            const hasSlots = slots.some(slot =>
                slot.clinic_id.toString() === clinicId &&
                normalizeString(slot.category) === normalizeString(reason) &&
                slotMatchesPatientAge(slot)
            );

            if (hasSlots) {
                option.classList.remove('opacity-50', 'cursor-not-allowed');
                option.classList.add('hover:border-pink-500', 'cursor-pointer');
                //if (unavailableMsg) unavailableMsg.classList.add('hidden');
                if (nameSpan) {
                    nameSpan.classList.remove('text-gray-400');
                    nameSpan.classList.add('text-gray-900');
                }
            } else {
                // option.classList.add('opacity-50', 'cursor-not-allowed');
                //option.classList.remove('hover:border-pink-500');
                //if (unavailableMsg) unavailableMsg.classList.remove('hidden');
                // if (nameSpan) { nameSpan.classList.add('text-gray-400'); nameSpan.classList.remove('text-gray-900'); }
            }
        });
    }

    // --- PRÉ-SÉLECTION DE LA CLINIQUE VIA PARAMÈTRE URL ---
    // Stocke l'ID de clinique à pré-sélectionner (issu de ?clinic=ID côté PHP).
    // La sélection effective est déclenchée dès que le motif est connu.
    let pendingPreselectedClinicId = null;

    /**
     * Coche la checkbox de la clinique pré-sélectionnée dans le DOM et déclenche
     * la mise à jour complète des filtres (comme un clic utilisateur normal).
     */
    function applyPreselectedClinic(clinicId) {
        if (!clinicId) return;
        const checkbox = document.querySelector(`input[name="clinics[]"][value="${clinicId}"]`);
        if (checkbox && !checkbox.checked) {
            checkbox.checked = true;
            // Déclencher le même pipeline que lors d'un clic utilisateur
            resetSelectedSlot();
            currentSelectedPractitioner = '';
            if (practitionerSearch) practitionerSearch.value = '';
            updateReasonPrices();
            updateReasonAvailability();
            updatePractitionerOptions();
            updateAllSubcategoriesAvailability();
            updateClinicAvailability();
            applyFilters();
        }
        pendingPreselectedClinicId = null;
    }

    // Déclenché par waitForSlotsBooking après la pré-sélection du motif (?motif=).
    // Exécute le même pipeline que lors d'un changement utilisateur sur le radio motif,
    // et coche la clinique pré-sélectionnée si elle est en attente.
    window.addEventListener('reason-changed', (e) => {
        resetSelectedSlot();
        updateReasonAvailability();
        updatePractitionerOptions();
        updateAllSubcategoriesAvailability();
        updateClinicAvailability();
        applyFilters();
        updateDescriptionsVisibility();

        if (pendingPreselectedClinicId) {
            applyPreselectedClinic(pendingPreselectedClinicId);
        }
    });

    // Déclenché par Alpine.js lorsqu'une clinique est pré-sélectionnée (?clinic=).
    // Si le motif est déjà sélectionné (cas sans ?motif= ou motif déjà coché), on coche
    // la clinique immédiatement ; sinon on attend que reason-changed soit émis.
    window.addEventListener('clinic-preselected', (e) => {
        const clinicId = e.detail?.clinicId;
        if (!clinicId) return;

        const currentReason = getSelectedReason();
        if (currentReason) {
            // Motif déjà sélectionné → on peut cocher la clinique tout de suite
            applyPreselectedClinic(clinicId);
        } else {
            // Motif pas encore sélectionné → stocker et attendre reason-changed
            pendingPreselectedClinicId = clinicId;
        }
    });

    // --- ÉCOUTEURS ---
    document.querySelectorAll('input[name="clinics[]"]').forEach(input => {
        input.addEventListener('change', () => {
            resetSelectedSlot();
            currentSelectedPractitioner = '';
            if (practitionerSearch) practitionerSearch.value = '';

            updateReasonPrices();
            updateReasonAvailability();
            updatePractitionerOptions();
            updateAllSubcategoriesAvailability();
            updateClinicAvailability();
            applyFilters();
        });
    });

    document.addEventListener('change', e => {
        if (e.target.name === 'reason') {
            resetSelectedSlot();
            updateReasonAvailability();
            updatePractitionerOptions();
            updateAllSubcategoriesAvailability();
            updateClinicAvailability();
            applyFilters();
            updateDescriptionsVisibility();
        }
    });

    window.addEventListener('subcategory-changed', (e) => {
        console.log('🔄 Sous-catégorie changée:', e.detail.catKey, '→', e.detail.subKey);
        resetSelectedSlot();
        currentSelectedPractitioner = '';
        if (practitionerSearch) practitionerSearch.value = '';
        updatePractitionerOptions();
        updateAllSubcategoriesAvailability();
        updateClinicAvailability();
        applyFilters();
    });

    // --- SUBMIT ---
    form.addEventListener('submit', e => {
        if (!selectedBookId.value) {
            e.preventDefault();
            slotError.classList.remove('hidden');
            slotError.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
    });

    // Au retour navigateur (BFCache/back_forward), repartir d'une sélection vide.
    window.addEventListener('pageshow', (event) => {
        const navEntries = typeof performance.getEntriesByType === 'function'
            ? performance.getEntriesByType('navigation')
            : [];
        const isBackForward = navEntries.length > 0 && navEntries[0].type === 'back_forward';

        if (event.persisted || isBackForward) {
            resetSelectedSlot();
            if (slotError) {
                slotError.classList.add('hidden');
            }
        }
    });

    // Initialiser immédiatement
    updateReasonPrices();
    updateReasonAvailability();
    updateClinicAvailability();
    updatePractitionerOptions();
    updateAllSubcategoriesAvailability();
    applyFilters();

    // Masquer le bouton "Autres" si non applicable pour l'âge initial (adulte par défaut)
    const otherReasonOptionInit = document.getElementById('other-reason-option');
    if (otherReasonOptionInit) {
        const agesWithAutresInit = (otherReasonOptionInit.dataset.agesWithAutres || '').split(',').filter(Boolean);
        if (agesWithAutresInit.length > 0 && !agesWithAutresInit.includes(currentPatientAge)) {
            otherReasonOptionInit.style.display = 'none';
        }
    }
}

